import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import { getUserNameByCpf } from './actions';

const INITIAL_STATE: ContactsByCpfState = {
  user: undefined,
  error: undefined,
};

const contactsByCpfReducer = createReducer<ContactsByCpfState>(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getUserNameByCpf.success, (state, action) => ({
    ...state,
    user: action.payload,
    error: '',
    contactsLoading: false,
  }))
  .handleAction(getUserNameByCpf.request, (state, action) => ({
    ...state,
    user: undefined,
    contactsLoading: true,
  }))
  .handleAction(getUserNameByCpf.failure, (state, action) => ({
    ...state,
    error: action.payload,
    contactsLoading: false,
  }));

export default contactsByCpfReducer;
